import { Skeleton } from 'ui/skeleton';
import {
  SidebarGroup,
  SidebarMenu,
  SidebarMenuItem,
} from '../../../ui/sidebar';

export const SidebarNavSkeleton = ({ count }: { count: number }) => (
  <SidebarGroup>
    <SidebarMenu>
      {Array.from({ length: count }, (_, i) => (
        <SidebarMenuItem
          key={i}
          style={{ opacity: count <= 1 ? 1 : 0.3 + (0.7 * i) / (count - 1) }}
        >
          <Skeleton className="h-8 w-full rounded-md" />
        </SidebarMenuItem>
      ))}
    </SidebarMenu>
  </SidebarGroup>
);
